export async function showHideChildrenByNames(object, namesArr, bool = false) {
    if (!object || !Array.isArray(namesArr) || namesArr.length === 0) return;

    object.traverse((child) => {
        if (namesArr.some((str) => child.name && child.name.includes(str))) {
            // Если это группа — переключаем всех её потомков
            if (child.isGroup) {
                child.traverse((nested) => {
                    if (!nested.name.includes("hitbox")) {
                        nested.visible = bool;
                    } else {
                        nested.visible = false;
                    }
                });
            } else {
                // Если это mesh или др. объект
                if (!child.name.includes("hitbox")) {
                    child.visible = bool;
                } else {
                    child.visible = false;
                }
            }
        }

        // Скрываем hitbox независимо
        if (child.name.includes("hitbox")) {
            child.visible = false;
        }
    });
}
